import { render, staticRenderFns } from "./MetodosComponent.vue?vue&type=template&id=aa867806&"
import script from "./MetodosComponent.vue?vue&type=script&lang=js&"
export * from "./MetodosComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports